import { createFileRoute, notFound } from '@tanstack/react-router';

import HowWeCompareAgentsPage from '@/pages/how-we-compare-agents/HowWeCompareAgentsPage';
import { getHowWeCompareAgents } from '@/sanity/how-we-compare-agents';
import { getHomeHeaderButton } from '@/sanity/landing-page';
import { getLegalLinks } from '@/sanity/legal-document';
import { howWeCompareAgentsPath } from '@/utils/how-we-compare-agents';
import { buildPageMeta } from '@/utils/seo';

const howWeCompareAgentsTitle = 'How we compare agents — Budgy';
const howWeCompareAgentsDescription =
  'Where Budgy gets letting agent fees and reviews, how we present them, and our policy on fake reviews.';

export const Route = createFileRoute('/how-we-compare-agents')({
  loader: async () => {
    const [howWeCompareAgents, headerButton, legalLinks] = await Promise.all([
      getHowWeCompareAgents(),
      getHomeHeaderButton(),
      getLegalLinks(),
    ]);
    if (!howWeCompareAgents) {
      throw notFound();
    }

    return { headerButton, howWeCompareAgents, legalLinks };
  },
  component: HowWeCompareAgentsPage,
  head: () =>
    buildPageMeta({
      title: howWeCompareAgentsTitle,
      description: howWeCompareAgentsDescription,
      path: howWeCompareAgentsPath,
    }),
});
